import { PaintedScene } from '../PaintedScene';

export const THE_CROSSING_PHASER_KEY = 'TheCrossingScene' as const;
export const THE_CROSSING_MANIFEST_KEY = 's-003-the-crossing' as const;

export class TheCrossingScene extends PaintedScene {
  constructor() {
    super(THE_CROSSING_PHASER_KEY, THE_CROSSING_MANIFEST_KEY);
  }
}
